import { render } from "./MobileHome.vue?vue&type=template&id=5b130d02&scoped=true&ts=true"
import script from "./MobileHome.vue?vue&type=script&lang=ts"
export * from "./MobileHome.vue?vue&type=script&lang=ts"

import "./MobileHome.vue?vue&type=style&index=0&id=5b130d02&lang=less&scoped=true"

import exportComponent from "/Users/jingshushu/homework/movie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b130d02"]])

export default __exports__